<section [formGroup]="stepForm">
  <div *ngIf="isRestoreFileDatabase"
       [attr.data-test-element]="elementsSelector.name.fileDatabaseBlock">
    <mbs-form-group>
      <mbs-destination-folder [disabled]="stepForm.get('destinationFolder').disabled"
                              [destinationLabel]="'wizards:destFolderDBLabel' | i18next"
                              [destinationNetworkLabel]="'wizards:destNetworkShareDBLabel' | i18next"
                              [forceValidate]="stepForm.get('destinationFolder').touched"
                              [params]="destinationFolderParams"
                              [(ngModel)]="destinationFolderData"
                              [ngModelOptions]="{ standalone: true }"
                              (ngModelChange)="destinationFolderDataChangeHandler()"></mbs-destination-folder>
    </mbs-form-group>
    <mbs-form-group>
      <mbs-switcher formControlName="createFolder"
                    [label]="'wizards:createFolder' | i18next"
                    [id]="'create-folder-switcher'"></mbs-switcher>
    </mbs-form-group>
    <mbs-form-group>
      <mbs-input formControlName="backupTemplate"
                 name="backupTemplate"
                 [label]="'wizards:backupTemplate' | i18next"
                 [id]="'backup-template-1'"
                 [validationWhitespace]="true"></mbs-input>
    </mbs-form-group>
  </div>

  <div *ngIf="isRestoreDatabase"
       [attr.data-test-element]="elementsSelector.name.databaseBlock">
    <mbs-form-group>
      <mbs-destination-folder [disabled]="stepForm.get('destinationFolder').disabled"
                              [destinationLabel]="'wizards:destFolderDB2Label' | i18next"
                              [destinationNetworkLabel]="'wizards:destNetworkShareDBLabel' | i18next"
                              [forceValidate]="stepForm.get('destinationFolder').touched"
                              [params]="destinationFolderParams"
                              [(ngModel)]="destinationFolderData"
                              [ngModelOptions]="{ standalone: true }"
                              (ngModelChange)="destinationFolderDataChangeHandler()"></mbs-destination-folder>
    </mbs-form-group>
    <mbs-form-group>
      <mbs-destination-folder [disabled]="stepForm.get('destinationFolderLog').disabled"
                              [destinationLabel]="'wizards:destFolderDBLogLabel' | i18next"
                              [destinationNetworkLabel]="'wizards:destNetworkShareDBLogLabel' | i18next"
                              [forceValidate]="stepForm.get('destinationFolderLog').touched"
                              [idPrefix]="'log'"
                              [params]="destinationFolderParams"
                              [(ngModel)]="destinationFolderLogData"
                              [ngModelOptions]="{ standalone: true }"
                              (ngModelChange)="destinationFolderDataChangeHandler('destinationFolderLog', 'destinationFolderLogData')"></mbs-destination-folder>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-input formControlName="backupTemplate"
                 name="backupTemplate"
                 [id]="'file-name-template'"
                 [label]="'wizards:fileNameTemplate' | i18next"
                 [validationWhitespace]="true"></mbs-input>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-switcher formControlName="closeConnection"
                    [label]="'wizards:closeConnection' | i18next"
                    [id]="'close-connection-checkbox'"></mbs-switcher>
    </mbs-form-group>

    <mbs-destination-table [(ngModel)]="overwriteAndSpecific"
                           [ngModelOptions]="{ standalone: true }"
                           (ngModelChange)="overwriteAndSpecificChangeHandler($event)"
                           [dataForItems]="itemsData"
                           [forceValidate]="forceValidate"
                           [isVirtual]="isVirtual"
                           [loadingTableData]="loadingTableData"
                           [planType]="planType"
                           [showState]="true"></mbs-destination-table>
  </div>
</section>
